// extracted by mini-css-extract-plugin
export default {"controlPanel":"ProjectList_controlPanel__VQwQD","title":"ProjectList_title__LwIqw","projectListArea":"ProjectList_projectListArea__QLm-f"};